import { KeenIcon } from '@/components';
const TimelinesWrapper = ({
  line,
  icon,
  iconNode,
  children,
  removeSpace
}) => {
  const hasCustomIcon = Boolean(iconNode);
  return <div className="flex items-start relative">
      {line && <div className="w-9 start-0 top-9 absolute bottom-0 rtl:-translate-x-1/2 translate-x-1/2 border-s border-s-gray-300"></div>}

      <div className={`flex items-center justify-center shrink-0 rounded-full size-9 ${hasCustomIcon ? 'bg-transparent border-0' : 'bg-gray-100 border border-gray-300 text-gray-600'}`}>
        {hasCustomIcon ? iconNode : <KeenIcon icon={icon} className="text-base" />}
      </div>
      <div className={`ps-2.5 ${!removeSpace ? 'mb-7' : ''} text-md grow`}>{children}</div>
    </div>;
};
export { TimelinesWrapper };
